import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RepresentacaoInstituicaoEnsino } from '../models/representacao-instituicao-ensino.model';
import { RepresentacaoInstituicaoEnsinoRedefinirSenha } from '../models/representacao-instituicao-ensino-redefinirSenha.model';

@Injectable({
  providedIn: 'root',
})
export class RepresentacaoInstituicaoEnsinoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all RepresentacaoInstituicaoEnsino
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: RepresentacaoInstituicaoEnsino[] }>(
        `${this.path}/getAllRepresentacaoInstituicaoEnsino`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response));
  }

  // Get RepresentacaoInstituicaoEnsino by ID
  public show(id: string): Observable<RepresentacaoInstituicaoEnsino> {
    return this.apiService
      .get<{ data: RepresentacaoInstituicaoEnsino }>(
        `${this.path}/getRepresentacaoInstituicaoEnsinoById/${id}`
      )
      .pipe(map((response) => response.data));
  }

  // Create new RepresentacaoInstituicaoEnsino
  /*
  public store(representacaoInstituicaoEnsino: RepresentacaoInstituicaoEnsino): Observable<RepresentacaoInstituicaoEnsino> {
    return this.apiService
      .post<{ object: RepresentacaoInstituicaoEnsino }>(`${this.path}/AddRepresentacaoInstituicaoEnsino`, representacaoInstituicaoEnsino)
      .pipe(
        map(response => response.object)
      );
  }*/
  public store(data: FormData): Observable<any> {
    return this.apiService.post<any>(
      `${this.path}/AddRepresentacaoInstituicaoEnsino`,
      data,
      {} // ou undefined se seu ApiService não exigir esse parâmetro
    );
  }

  // Create new RepresentacaoInstituicaoEnsinoRange
  public storeRange(
    representacaoInstituicaoEnsino: RepresentacaoInstituicaoEnsino
  ): Observable<RepresentacaoInstituicaoEnsino> {
    return this.apiService
      .post<{ object: RepresentacaoInstituicaoEnsino }>(
        `${this.path}/AddRepresentacaoInstituicaoEnsinoRange`,
        representacaoInstituicaoEnsino
      )
      .pipe(map((response) => response.object));
  }

  // Update existing RepresentacaoInstituicaoEnsino
  public update(
    representacaoInstituicaoEnsino: any
  ): Observable<any> {
    return this.apiService
      .put<{ object: RepresentacaoInstituicaoEnsino }>(
        `${this.path}/UpdateRepresentacaoInstituicaoEnsino`,
        representacaoInstituicaoEnsino
      )
      .pipe(map((response) => response));
  }

  // Delete existing RepresentacaoInstituicaoEnsino
  public delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteRepresentacaoInstituicaoEnsinoById/${id}`
    );
  }

  getFotoRepresentacaoInstituicaoEnsinoById(id: number): Observable<Blob> {
    return this.apiService.get(
      `${this.path}/GetRepresentacaoInstituicaoEnsinoLogotipoById/${id}`,
      new HttpParams(),
      false,
      'blob'
    );
  }

  redefinirSenha(data: RepresentacaoInstituicaoEnsinoRedefinirSenha): Observable<any> {
    const params = new HttpParams()
    .set('username', data.username)
    .set('email', data.email)
    .set('novasenha', data.novasenha);

    // Passa corpo vazio {} e o objeto options com 'params' (HttpParams)
    return this.apiService.post<any>(
      `${this.path}/Redefinir-senha`,
      {},        // corpo vazio igual ao curl -d ''
      { params } // passa os parâmetros como query string
    );
  }
  

  /*redefinirSenha(payload: any): Observable<any>{
    return this.apiService
      .post<any>(
        `${this.path}/Redefinir-senha`,
        payload,
        {} // ou undefined se seu ApiService não exigir esse parâmetro
      )
  }*/
}
